export const emailValidationRFC2822 =
  "[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?";
export const phoneValidation = "^(\\+1|1)?[0-9]{10}$";
export const passwordValidation =
  "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$";
export const referralRegex =
  "^([0-9]{10}|\\([0-9]{3}\\)[0-9]{3}-?[0-9]{4}|\\([0-9]{3}\\) [0-9]{3}-?[0-9]{4}|[0-9]{3} [0-9]{3}(-)?[0-9]{4}|[0-9]{3} [0-9]{3} [0-9]{4})$";
export const referralValidation = `${referralRegex}|${emailValidationRFC2822}`;
